var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-switch=\"mode\" class=\"text-display\"><div ng-switch-when=\"edit\"><h5>{{ field.label }}</h5></div><div ng-switch-when=\"view\"><div ng-class=\"{white: (index + 1) % 2 == 0}\" class=\"colorcont clearfix\"><p class=\"app-display\">{{ field.label }}</p></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/freeforms/text_display/text_display.jade
// module id = 405
// module chunks = 0